/* ==========================================================================
   ABC Dentalworks - product photo gallery + full-screen viewer
   assets/abcd-parts-gallery.js                           rev 1  2026-10-02
   Markup: snippets/abcd-parts-gallery.liquid. No dependencies.
   ========================================================================== */
(function () {
  var gal = document.querySelector('[data-pop-gal]');
  var dataEl = document.getElementById('pop-gal-data');
  if (!gal || !dataEl || gal.__popInit) return;
  gal.__popInit = true;

  var items;
  try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!items || !items.length) return;

  var stage = gal.querySelector('.stage');
  var stageImg = document.getElementById('pop-stage-img');
  var stageBtn = gal.querySelector('[data-pop-open]');
  var curEl = gal.querySelector('[data-pop-cur]');
  var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.thumbs button'));
  var idx = 0;
  var finePointer = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var LENS_MIN = 1400;   /* only hover-zoom photos with real detail behind them */
  var ZOOM_MIN = 1000;   /* below this the viewer enlarges but offers no 1:1 zoom */

  function wrap(i) { return (i + items.length) % items.length; }

  /* ---- stage --------------------------------------------------------- */
  function show(i) {
    idx = wrap(i);
    var it = items[idx];
    if (stageImg) {
      stage.classList.add('is-swapping');
      var pre = new Image();
      pre.onload = pre.onerror = function () {
        stageImg.srcset = it.srcset;
        stageImg.src = it.src;
        stageImg.alt = it.alt || '';
        if (it.w && it.h) { stageImg.width = it.w; stageImg.height = it.h; }
        stage.classList.remove('is-swapping');
      };
      pre.sizes = stageImg.sizes;
      pre.srcset = it.srcset;
      pre.src = it.src;
    }
    if (curEl) curEl.textContent = idx + 1;
    thumbs.forEach(function (t, n) {
      t.setAttribute('aria-current', n === idx ? 'true' : 'false');
      if (n === idx && t.scrollIntoView && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
        t.parentNode.scrollLeft = t.offsetLeft - t.parentNode.clientWidth / 2 + t.offsetWidth / 2;
      }
    });
    lensOff();
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-pop-idx'), 10) || 0); });
  });
  Array.prototype.forEach.call(gal.querySelectorAll('.stage [data-pop-step]'), function (b) {
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      show(idx + parseInt(b.getAttribute('data-pop-step'), 10));
    });
  });

  /* hover lens: magnify under the cursor, desktop only, big photos only */
  function lensOff() {
    if (!stageImg) return;
    stage.classList.remove('is-lens');
    stageImg.style.transform = '';
    stageImg.style.transformOrigin = '';
  }
  if (stageImg && finePointer) {
    stageBtn.addEventListener('mousemove', function (e) {
      if ((items[idx].w || 0) < LENS_MIN) return;
      var r = stageImg.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      stage.classList.add('is-lens');
      stageImg.style.transformOrigin = x + '% ' + y + '%';
      stageImg.style.transform = 'scale(2.2)';
    });
    stageBtn.addEventListener('mouseleave', lensOff);
  }

  /* swipe on the stage (touch) */
  function swipe(el, onLeft, onRight) {
    var sx = 0, sy = 0, tracking = false;
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        el.__swiped = true; setTimeout(function () { el.__swiped = false; }, 350);
        if (dx < 0) onLeft(); else onRight();
      }
    }, { passive: true });
  }
  if (items.length > 1 && stageBtn) swipe(stageBtn, function () { show(idx + 1); }, function () { show(idx - 1); });

  /* ---- full-screen viewer ------------------------------------------- */
  var lb, lbScroll, lbImg, lbCount, lbThumbs, lbTip, lastFocus;
  var ICON = {
    x: '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    l: '<svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg>',
    r: '<svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg>'
  };

  function build() {
    lb = document.createElement('div');
    lb.className = 'pop-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product photos');
    var many = items.length > 1;
    lb.innerHTML =
      '<div class="pop-lb-bar">' +
        '<span class="pop-lb-count"></span>' +
        '<span class="pop-lb-tip"></span>' +
        '<button type="button" class="pop-lb-btn" data-lb-close aria-label="Close">' + ICON.x + '</button>' +
      '</div>' +
      '<div class="pop-lb-scroll"><img alt=""></div>' +
      '<span class="pop-lb-low">Original photo is low resolution - shown at its largest useful size</span>' +
      (many ? '<div class="pop-lb-side prev"><button type="button" class="pop-lb-btn" data-lb-step="-1" aria-label="Previous photo">' + ICON.l + '</button></div>' +
              '<div class="pop-lb-side next"><button type="button" class="pop-lb-btn" data-lb-step="1" aria-label="Next photo">' + ICON.r + '</button></div>' : '') +
      (many ? '<div class="pop-lb-thumbs"></div>' : '');
    document.body.appendChild(lb);

    lbScroll = lb.querySelector('.pop-lb-scroll');
    lbImg = lbScroll.querySelector('img');
    lbCount = lb.querySelector('.pop-lb-count');
    lbTip = lb.querySelector('.pop-lb-tip');
    lbThumbs = lb.querySelector('.pop-lb-thumbs');

    if (lbThumbs) {
      items.forEach(function (it, n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Photo ' + (n + 1));
        b.innerHTML = '<img alt="" loading="lazy" src="' + it.src.replace(/width=\d+/, 'width=160') + '">';
        b.addEventListener('click', function () { lbShow(n); });
        lbThumbs.appendChild(b);
      });
    }

    lb.querySelector('[data-lb-close]').addEventListener('click', close);
    Array.prototype.forEach.call(lb.querySelectorAll('[data-lb-step]'), function (b) {
      b.addEventListener('click', function () { lbShow(idx + parseInt(b.getAttribute('data-lb-step'), 10)); });
    });
    /* click the dark backdrop (not the photo) to close */
    lbScroll.addEventListener('click', function (e) {
      if (e.target === lbScroll && !lbScroll.classList.contains('is-zoomed')) close();
    });

    /* zoom: click/tap the photo to toggle 1:1, drag (or native scroll) to pan */
    var drag = null, moved = false;
    lbImg.addEventListener('click', function (e) {
      if (moved) { moved = false; return; }
      if (lbScroll.__swiped) return;
      toggleZoom(e);
    });
    lbScroll.addEventListener('mousedown', function (e) {
      if (!lbScroll.classList.contains('is-zoomed')) return;
      drag = { x: e.clientX, y: e.clientY, l: lbScroll.scrollLeft, t: lbScroll.scrollTop };
      moved = false;
      lbScroll.classList.add('is-dragging');
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (Math.abs(dx) + Math.abs(dy) > 4) moved = true;
      lbScroll.scrollLeft = drag.l - dx;
      lbScroll.scrollTop = drag.t - dy;
    });
    window.addEventListener('mouseup', function () {
      if (!drag) return;
      drag = null;
      lbScroll.classList.remove('is-dragging');
    });

    if (many) swipe(lbScroll, function () {
      if (!lbScroll.classList.contains('is-zoomed')) lbShow(idx + 1);
    }, function () {
      if (!lbScroll.classList.contains('is-zoomed')) lbShow(idx - 1);
    });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') { if (lbScroll.classList.contains('is-zoomed')) unzoom(); else close(); }
      else if (e.key === 'ArrowRight' && many) lbShow(idx + 1);
      else if (e.key === 'ArrowLeft' && many) lbShow(idx - 1);
      else if (e.key === 'Tab') {
        var f = lb.querySelectorAll('button');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      }
    });
  }

  function canZoom(it) { return (it.w || 0) >= ZOOM_MIN; }

  function unzoom() {
    lbScroll.classList.remove('is-zoomed');
    lb.classList.remove('is-zoomed-state');
    lbImg.style.width = '';
    setTip();
  }

  function toggleZoom(e) {
    var it = items[idx];
    if (!canZoom(it)) return;
    if (lbScroll.classList.contains('is-zoomed')) { unzoom(); return; }
    var r = lbImg.getBoundingClientRect();
    var fx = e && r.width ? (e.clientX - r.left) / r.width : 0.5;
    var fy = e && r.height ? (e.clientY - r.top) / r.height : 0.5;
    var target = Math.min(it.w, 2400);
    /* never zoom to less than 1.6x of what is already on screen */
    target = Math.max(target, Math.round(r.width * 1.6));
    lbScroll.classList.add('is-zoomed');
    lb.classList.add('is-zoomed-state');
    lbImg.style.width = target + 'px';
    var h = target * (it.h / it.w || r.height / r.width);
    lbScroll.scrollLeft = Math.max(0, fx * target - lbScroll.clientWidth / 2);
    lbScroll.scrollTop = Math.max(0, fy * h - lbScroll.clientHeight / 2);
    setTip();
  }

  function setTip() {
    if (!lbTip) return;
    var zoomed = lbScroll.classList.contains('is-zoomed');
    lbTip.textContent = !canZoom(items[idx]) ? '' :
      zoomed ? 'Drag to look around - click to zoom out' : 'Click the photo to zoom in';
  }

  function lbShow(i) {
    idx = wrap(i);
    var it = items[idx];
    unzoom();
    lbScroll.classList.toggle('no-zoom', !canZoom(it));
    lbImg.removeAttribute('srcset');
    lbImg.src = it.src;            /* fast first paint ... */
    var hi = new Image();          /* ... then swap to the full-size file */
    hi.onload = function () { if (items[idx] === it) lbImg.src = it.full; };
    hi.src = it.full;
    lbImg.alt = it.alt || '';
    lbCount.textContent = items.length > 1 ? (idx + 1) + ' / ' + items.length : '';
    if (lbThumbs) {
      Array.prototype.forEach.call(lbThumbs.children, function (b, n) {
        b.setAttribute('aria-current', n === idx ? 'true' : 'false');
      });
    }
    setTip();
    show(idx);                     /* keep the page gallery in step */
  }

  function open() {
    if (stageBtn && stageBtn.__swiped) return;
    if (!lb) build();
    lastFocus = document.activeElement;
    lb.classList.add('is-open');
    document.documentElement.classList.add('pop-lb-open');
    lbShow(idx);
    var c = lb.querySelector('[data-lb-close]');
    if (c) c.focus();
  }

  function close() {
    unzoom();
    lb.classList.remove('is-open');
    document.documentElement.classList.remove('pop-lb-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  if (stageBtn) stageBtn.addEventListener('click', open);
  var hintT = gal.querySelector('.pop-hint-t');
  if (hintT && !finePointer) hintT.textContent = 'Tap to enlarge';
})();
